import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import InputField from 'components/InputField';
import validations from 'validations';

import './PricesField.styles.scss';
import './PricesField.styles.responsive.scss';

const PricesField: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="prices-field">
      <Field
        name="revenue"
        label={t('revenue')}
        numberStyle="dottedNumber"
        component={InputField}
        placeholder={t('amountPlaceholder')}
        required
        validate={validations.composeValidators(
          validations.required(),
          validations.positiveNumbersOnly(t('onlyPositiveNumbersAreAllowed')),
        )}
      />
      <Field
        name="netAssets"
        label={t('netAssetsLabel')}
        numberStyle="dottedNumber"
        component={InputField}
        placeholder={t('amountPlaceholder')}
        validate={validations.positiveNumbersOnly(
          t('onlyPositiveNumbersAreAllowed'),
        )}
      />
    </div>
  );
};

export default PricesField;
